import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBidBtn',
  props: {
    userBidProp: {},
    placeBidProp: {}
  },
  emits: ["selectBid"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const btnLabel = computed(() => {
    let result = trans("lot.card_info_block.buttons.place_bid");
    if (props.userBidProp) {
      result =
        props.placeBidProp === "lot-page"
          ? trans("lot.card_info_block.buttons.rise_your_bid")
          : trans("lot.card_info_block.buttons.rise_bid");
    }

    return result;
  });

  const selectBid = () => {
    emit("selectBid");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "fast-bid-btn btn btn-blue",
    onClick: selectBid
  }, _toDisplayString(btnLabel.value), 1))
}
}

})